import {Component, Inject, Injector, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {TakeUntilComponentDestroy} from '@q9elements/ui-kit/common';
import {RmeNodeDaoAbstractService} from '../../../../../core/abstract/rme-node-dao-abstract.service';
import {
  DeleteDialogData,
  TranslationsInterface
} from '../../../custom-metadata-view/dialogs/models/create-new-view.interface';
@Component({
  selector: 'delete-node-dialog',
  templateUrl: './delete-node-base-dialog.component.html',
  styleUrls: ['./delete-node-base-dialog.component.scss']
})
export class DeleteNodeBaseDialogComponent extends TakeUntilComponentDestroy implements OnInit {
  public loading: boolean;
  public translations: TranslationsInterface;

  constructor(
    public dialogRef: MatDialogRef<DeleteNodeBaseDialogComponent>,
    protected nodeService: RmeNodeDaoAbstractService,
    protected translate: TranslateService,
    protected injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: DeleteDialogData
  ) {
    super();
  }

  ngOnInit() {
    this.setTranslations();
  }

  public deleteNode(): void {
    this.loading = true;
    this.nodeService
      .deleteNode(this.data.refModelId, this.data.nodeId, this.data.internalNode)
      .pipe(this.takeUntilComponentDestroy())
      .subscribe(
        () => {
          this.loading = false;
          this.dialogRef.close(true);
        },
        () => {
          this.dialogRef.close(false);
        }
      );
  }

  protected setTranslations() {
    this.translations = {
      title: this.translate.instant('POPUPS.DELETE_NODE'),
      text: this.translate.instant('POPUPS.DELETE_NODE_TEXT', {name: this.data.nodeName})
    };
  }
}
